import { isRemote } from '../env';
import { LocalTurnoGeoRepository } from './localRepository';
import { RemoteTurnoGeoRepository } from './remoteRepository';
import { ITurnoGeoRepository } from './ITurnoGeoRepository';
import { getAuthToken } from '../../auth/tokenProvider';

let instance: ITurnoGeoRepository | null = null;

export function getTurnoGeoRepository(getToken?: () => Promise<string | null>): ITurnoGeoRepository {
  if (!instance) {
    instance = isRemote ? new RemoteTurnoGeoRepository(getToken ?? getAuthToken) : new LocalTurnoGeoRepository();
  }
  return instance;
}
